import "./App.css";

import React, { useState } from "react";
import Navbar from "./components/Navbar";
import News from "./components/News";

import { HashRouter as Router, Routes, Route } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
export default function App() {
  const size = 9;
  const apiKey = process.env.REACT_APP_NEWS_API;

  const [progress, setProgress] = useState(0);

  return (
    <div>
      <Router>
        <Navbar />
        <LoadingBar
          height={3}
          color="#f11946"
          progress={progress}
          // onLoaderFinished={() => setProgress(0)}
        />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="top"
                country="in"
                category="top"
                size={size}
              />
            }
          />
          <Route
            exact
            path="/education"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="education"
                country="in"
                category="education"
                size={size}
              />
            }
          />
          <Route
            exact
            path="/politics"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="politics"
                country="in"
                category="politics"
                size={size}
              />
            }
          />
          <Route
            exact
            path="/sports"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="sports"
                country="in"
                category="sports"
                size={size}
              />
            }
          />
          <Route
            exact
            path="/technology"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="technology"
                country="in"
                category="technology"
                size={size}
              />
            }
          />
          <Route
            exact
            path="/business"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="business"
                country="in"
                category="business"
                size={size}
              />
            }
          />
          <Route
            exact
            path="/science"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="science"
                country="in"
                category="science"
                size={size}
              />
            }
          />
          <Route
            exact
            path="/entertainment"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="entertainment"
                country="in"
                category="entertainment"
                size={size}
              />
            }
          />
          <Route
            exact
            path="/world"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                key="world"
                country="in"
                category="world"
                size={size}
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
}
